import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoImage from '../assets/images/logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
                  <div className="footer-logo">
          <Link to="/">
            <img src={logoImage} alt="Sipelius kotipalvelu logo - Laadukkaat kotipalvelut Lahdessa" />
            </Link>
            <p className="footer-tagline">Yhdessä paras!</p>
          </div>
          
          <div className="footer-contact">
            <a href="tel:0442465506" className="phone-number">
              044 246 5506
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 